import { render, staticRenderFns } from "./MerchantSettled.vue?vue&type=template&id=4abd49bc&scoped=true&"
import script from "./MerchantSettled.vue?vue&type=script&lang=js&"
export * from "./MerchantSettled.vue?vue&type=script&lang=js&"
import style0 from "./MerchantSettled.vue?vue&type=style&index=0&id=4abd49bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd49bc",
  null
  
)

export default component.exports